export default {
  // Általános
  title: 'Projektek',
  subtitle: 'Projektjei kezelése és nyomon követése',
  new: 'Új projekt',
  edit: 'Projekt szerkesztése',
  view: 'Projekt megtekintése',
  delete: 'Projekt törlése',
  noProjects: 'Nincsenek projektek',
  noProjectsDescription: 'Kezdjen el egy új projekt létrehozásával.',
  searchPlaceholder: 'Keresés projektekben...',
  resultsCount: 'Eredmények',
  
  // Mezők
  fields: {
    name: 'Projekt neve',
    description: 'Leírás',
    status: 'Státusz',
    priority: 'Prioritás',
    startDate: 'Kezdés dátuma',
    endDate: 'Befejezés dátuma',
    customer: 'Ügyfél',
    assignedUsers: 'Hozzárendelt felhasználók',
    selectedUsers: 'Kijelölt felhasználók',
    progress: 'Haladás',
    budget: 'Költségvetés',
    actualCost: 'Tényleges költség',
    tags: 'Címkék',
    notes: 'Megjegyzések',
    documents: 'Dokumentumok',
    tasks: 'Feladatok',
    createdAt: 'Létrehozva',
    updatedAt: 'Módosítva',
    createdBy: 'Létrehozta'
  },
  
  // Szekciók
  sections: {
    basicInfo: 'Alapvető információk',
    timeProgress: 'Időzítés és haladás',
    teamClient: 'Csapat és ügyfél',
    financeTags: 'Pénzügyek és címkék',
    tasks: 'Kapcsolódó feladatok'
  },
  
  // Formok
  form: {
    basicInfo: 'Alapvető információk',
    timing: 'Időzítés és költségvetés',
    teamAndClient: 'Ügyfél és csapat', 
    tagsAndNotes: 'Címkék és megjegyzések'
  },
  
  // Placeholder-ek
  placeholders: {
    name: 'Adja meg a projekt nevét',
    description: 'Adja meg a projekt leírását',
    customer: 'Válasszon ügyfelet...',
    assignedUsers: 'Válasszon felhasználókat...',
    budget: 'Adja meg a költségvetést',
    tags: 'Új címke...',
    notes: 'További megjegyzések...',
    documents: 'Csatolja a projekthez kapcsolódó dokumentumokat'
  },
  
  // Státuszok
  status: {
    planning: 'Tervezés',
    active: 'Aktív',
    completed: 'Befejezett',
    paused: 'Szünetel',
    cancelled: 'Megszakítva'
  },
  
  // Prioritások
  priority: {
    low: 'Alacsony',
    medium: 'Közepes',
    high: 'Magas',
    urgent: 'Sürgős'
  },
  
  // Statisztikák
  stats: {
    total: 'Összes projekt',
    active: 'Aktív',
    completed: 'Befejezett',
    overdue: 'Lejárt',
    averageProgress: 'Átlagos haladás'
  },
  
  // Validációs üzenetek
  validation: {
    nameRequired: 'A projekt neve kötelező',
    descriptionRequired: 'A leírás kötelező',
    dateRange: 'A befejezés dátuma nem lehet korábbi a kezdés dátumánál',
    budgetPositive: 'A költségvetés pozitív szám kell legyen'
  },
  
  // Műveletek
  actions: {
    create: 'Projekt létrehozása',
    update: 'Projekt frissítése',
    delete: 'Projekt törlése',
    addTask: 'Feladat hozzáadása',
    removeTask: 'Feladat eltávolítása',
    calculateProgress: 'Haladás számítása',
    manageTasks: 'Feladatok kezelése'
  },
  
  // Üzenetek
  messages: {
    created: 'Projekt sikeresen létrehozva',
    createSuccess: 'Projekt sikeresen létrehozva',
    updated: 'Projekt sikeresen frissítve',
    updateSuccess: 'Projekt sikeresen frissítve',
    deleted: 'Projekt sikeresen törölve',
    statusUpdated: 'Státusz sikeresen frissítve',
    priorityUpdated: 'Prioritás sikeresen frissítve',
    progressUpdated: 'Haladás sikeresen frissítve',
    taskAdded: 'Feladat hozzáadva a projekthez',
    taskRemoved: 'Feladat eltávolítva a projektből',
    noTasks: 'Nincs kapcsolódó feladat',
    createError: 'Hiba a projekt létrehozásakor',
    updateError: 'Hiba a projekt frissítésekor',
    deleteError: 'Hiba a projekt törlésekor',
    statusUpdateError: 'Hiba a státusz frissítésekor',
    priorityUpdateError: 'Hiba a prioritás frissítésekor',
    progressUpdateError: 'Hiba a haladás frissítésekor'
  },
  
  // Megerősítő üzenetek
  confirmDelete: 'Biztosan törölni szeretné ezt a projektet?',
  confirmDeleteMessage: 'Ez a művelet nem visszavonható. A projekt összes adata elvész.',
  
  // Szűrők
  filters: {
    all: 'Minden projekt',
    my: 'Saját projektek',
    active: 'Aktív projektek',
    completed: 'Befejezett projektek',
    overdue: 'Lejárt projektek'
  },
  
  // Időzítés
  overdue: 'Lejárt',
  dueSoon: 'Hamarosan lejár',
  dueIn: '{{days}} nap múlva jár le',
  completedOn: 'Befejezve: {{date}}',
  
  // Projekt részletek
  details: {
    overview: 'Áttekintés',
    tasks: 'Feladatok',
    timeline: 'Idővonal',
    budget: 'Költségvetés',
    team: 'Csapat',
    documents: 'Dokumentumok',
    notes: 'Megjegyzések'
  },
  
  // Progressz
  progress: {
    notStarted: 'Nem kezdődött el',
    inProgress: 'Folyamatban',
    completed: 'Befejezett',
    percentage: '{{progress}}% kész'
  }
}; 